import SideBar from '../components/SideBar';
import Header from '../components/Header';
import OrderStatusCard from '../components/OrderStatusCard';
import {ReactComponent as LaundryMachineIcon} from '../components/svgs/laundrymachineicon.svg';
import {ReactComponent as ShippingBoxIcon} from '../components/svgs/shippingboxicon.svg';

import { ReactComponent as DashboardIcon } from '../components/svgs/dashboardicon.svg';
import { ReactComponent as OrderIcon } from '../components/svgs/ordersicon.svg';
import { ReactComponent as CustomerIcon } from '../components/svgs/customersicon.svg';


import StatusDropdown from '../components/StatusDropdown';
import OrderTab from '../components/OrderTab';

// laundry status data
const laundryStatus = [
  { label: 'All', link: '#' },
  { label: 'Binned', link: '#' },
  { label: 'Washing', link: '#' },
  { label: 'Drying', link: '#' },
  { label: 'Folding', link: '#' },
];

// laundry days data
const laundryDays = [
  { label: 'Today', link: '#' },
  { label: 'Last 7 Days', link: '#' },
  { label: 'Last 14 Days', link: '#' },
  { label: 'Last 30 Days', link: '#' },
  { label: 'All Time', link: '#' },
];

const AttendantSidebarLinks = [
  { to: '/', icon: <DashboardIcon />, text: 'Dashboard', isActive: false },
  { to: '/orders', icon: <OrderIcon />, text: 'Orders', isActive: true },
  { to: '/customers', icon: <CustomerIcon />, text: 'Customers', isActive: false },

];

const OrderScreen = () => {

  return (
    <>

      <section className='dashboard-container flex '>
        <aside className=''>
        <SideBar links={AttendantSidebarLinks} />
        </aside>
        <main className='main-container mb-32'>
            <Header orderTitle={'Orders'} orderSubtitle={'Manage order'} showButton={true} /> 
          <section className='mt-10 flex gap-5'>
            {/*  */}
            <OrderStatusCard icon={<LaundryMachineIcon/>} noOfOrders={23} noOfOrdersClassName="custom-style" dueDay={"In Laundry"} orderText={'orders'} size={'24'} dueDate={new Date()} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All'} className="ml-20" />}/>
            <OrderStatusCard icon={<ShippingBoxIcon/>} noOfOrders={19} noOfOrdersClassName="custom-style" dueDay={"Ready for Pickup"} orderText={'orders'} size={'12'} dueDate={new Date()} dropDown={<StatusDropdown options={laundryDays} dropdownText={'Today'} className="status-card-dropdown-today" />}/>
          </section>
          <section className='mt-20 flex gap-4'>
            <section>
              <OrderTab />
            </section>
            {/* <section className='side-card-section'>
              <SideCard/>
            </section> */}
          </section>
        </main>
      </section>

    </>
  )
}
export default OrderScreen